"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var player_image_banner_1 = require("player-image-banner");
exports.ImageBanner = player_image_banner_1.default;
var JobDetailsBannerContent_1 = require("../JobDetailsBannerContent/JobDetailsBannerContent");
exports.JobDetailsBannerContent = JobDetailsBannerContent_1.JobDetailsBannerContent;
var Panel_1 = require("player-layout-controls/controls/Panel");
exports.LayoutControlsPanel = Panel_1.Panel;
var JobDetailsBanner = (function (_super) {
    __extends(JobDetailsBanner, _super);
    function JobDetailsBanner(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign({}, _this.view.state, _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    JobDetailsBanner.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign({}, _this.view.state, _this.props)
                });
            })
            : null;
    };
    JobDetailsBanner.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    JobDetailsBanner.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    JobDetailsBanner.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign({}, this.state.viewModel, this.view.state, this.props)
        }, cb ? cb : function () { });
    };
    JobDetailsBanner.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign({}, viewModel, viewState, props) });
    };
    JobDetailsBanner.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    JobDetailsBanner.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    JobDetailsBanner.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    JobDetailsBanner.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(PlayerSwitch, { key: 0, value: $this.state.viewModel.hasBannerImg, true: [React.createElement(player_image_banner_1.default, { key: 0, src: $this.state.viewModel.backgroundImage, overlayColor: "Black", hasOverlay: true, alt: "banner image", overlayStrength: "Light", contentHeight: $this.state.viewModel.bannerContentHeight, imageType: "Background", backgroundImageSize: "Cover", returnRef: _this._proxyEvent("setContentHeight"), children: [React.createElement(JobDetailsBannerContent_1.JobDetailsBannerContent, { key: 0, backgroundImage: $this.state.viewModel.backgroundImage, reqId: $this.state.viewModel.reqId, reqTitle: $this.state.viewModel.reqTitle, location: $this.state.viewModel.location, applyNowButtonText: $this.state.viewModel.applyNowButtonText, shareBtnText: $this.state.viewModel.shareBtnText, shareOptions: $this.state.viewModel.shareOptions, isApplyNowButtonDisabled: $this.state.viewModel.isApplyNowButtonDisabled, saveJobText: $this.state.viewModel.saveJobText, isSaveJobDisabled: $this.state.viewModel.isSaveJobDisabled, bannerContentHeight: $this.state.viewModel.bannerContentHeight, postedDateLabel: $this.state.viewModel.postedDateLabel, onApplyClick: _this._proxyEvent("onApplyClick"), onSaveClick: _this._proxyEvent("onSaveClick"), onShareClick: _this._proxyEvent("onShareClick"), setContentHeight: _this._proxyEvent("setContentHeight") })] })], false: [React.createElement(Panel_1.Panel, { key: 0, backgroundColor: "Grey40", children: [React.createElement(JobDetailsBannerContent_1.JobDetailsBannerContent, { key: 0, backgroundImage: $this.state.viewModel.backgroundImage, reqId: $this.state.viewModel.reqId, reqTitle: $this.state.viewModel.reqTitle, location: $this.state.viewModel.location, applyNowButtonText: $this.state.viewModel.applyNowButtonText, shareBtnText: $this.state.viewModel.shareBtnText, shareOptions: $this.state.viewModel.shareOptions, isApplyNowButtonDisabled: $this.state.viewModel.isApplyNowButtonDisabled, saveJobText: $this.state.viewModel.saveJobText, isSaveJobDisabled: $this.state.viewModel.isSaveJobDisabled, bannerContentHeight: $this.state.viewModel.bannerContentHeight, postedDateLabel: $this.state.viewModel.postedDateLabel, onApplyClick: _this._proxyEvent("onApplyClick"), onSaveClick: _this._proxyEvent("onSaveClick"), onShareClick: _this._proxyEvent("onShareClick"), setContentHeight: _this._proxyEvent("setContentHeight") })] })] })];
        };
        return (React.createElement("div", { className: "p-view-jobdetailsbanner" }, this.state.isInit ? root_handler() : null));
    };
    return JobDetailsBanner;
}(React.Component));
JobDetailsBanner.defaultProps = {
    backgroundImage: "", reqId: "", reqTitle: "", location: "", applyNowButtonText: "", shareBtnText: "", shareOptions: "", isApplyNowButtonDisabled: "", saveJobText: "", isSaveJobDisabled: "", bannerContentHeight: "", postedDateLabel: "", onApplyClick: function () { }, onSaveClick: function () { }, onShareClick: function () { }, setContentHeight: function () { }
};
exports.JobDetailsBanner = JobDetailsBanner;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["JobDetailsBanner"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobDetailsBanner/JobDetailsBanner.js
// module id = 966
// module chunks = 0